/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpApiUtil from '@api-util/mbp';
import mbpApiBrand from '@brand-api/mbp';
import mbpConfigServerApi from '@config-server-api/mbp';
import mbpLogger from '@module-logger/mbp';
import sdkFeatureFlags from '@feature-flags-sdk/mbp';

import cookies from '../../app/helpers/common/storage/cookies';

const context = {
    mbpApiUtil,
    mbpApiBrand,
    mbpConfigServerApi,
    mbpLogger,
    sdkFeatureFlags,

    cookies,
};

export default context;
